<template>
  <div class="fixed top-0 header flex items-center justify-between w-full border-b shadow-md bg-white p-4 md:p-5 md:px-10">
    <div class="md:w-3/12 flex items-center">
      <p class="text-2xl md:text-3xl font-bold"><router-link to="/user"><span style="color: rgb(242, 19, 93)">á</span>ptitude</router-link></p>
    </div>
    <div class="block md:hidden">
      <vs-button class="ml-2" color="danger" type="border" icon="menu"></vs-button>
      <vs-button class="ml-2" color="danger" type="relief" icon="login" @click="popupActivo2=false; popupActivo=true"></vs-button>
    </div>
    <ul class="hidden md:flex items-center justify-center gap-5 w-6/12">
      <li> <vs-button class="font-bold" @click="changeActiveLink('Home')" type="line" :color="activeLink === 'Home' ? 'danger' : 'dark'">Home</vs-button> </li>
      <li> <vs-button class="font-bold" @click="changeActiveLink('Videos')" type="line" :color="activeLink === 'Videos' ? 'danger' : 'dark'">Trainings</vs-button> </li>
      <li> <vs-button class="font-bold" @click="changeActiveLink('Profile');" type="line" :color="activeLink === 'Profile' ? 'danger' : 'dark'">Profile</vs-button> </li>
      <li> <vs-button class="font-bold" type="line" :color="activeLink === 'nutrition' ? 'danger' : 'dark'" disabled>Nutrition</vs-button> </li>
      <li> <vs-button class="font-bold" type="line" :color="activeLink === 'subscriptions' ? 'danger' : 'dark'" disabled>Subscription</vs-button> </li>
      <li> <vs-button class="font-bold" type="line" :color="activeLink === 'faqs' ? 'danger' : 'dark'" disabled>FAQs</vs-button> </li>
    </ul>
    <div class="w-3/12 hidden md:flex items-center justify-end font-bold">
    <ul class="flex items-center justify-end gap-1 ">
      <li> <vs-button class="font-medium" type="gradient" color="danger" to="/">Sign Out</vs-button> </li>  
    </ul>
    </div>
  </div>
</template>

<script>
export default {
  emits:['change-component'],
  data(){
    return{
      activeLink: this.$route.name || "Home",
    }
  },
  methods:{
    changeActiveLink(goTo){
      this.activeLink = goTo;
      window.scrollTo(0, 0);
      this.$router.push({name: goTo})
    },

  }
}
</script>

<style lang="stylus">
.header{
  z-index: 99999;
}
</style>